<dx-date-range-box
  class="date-range-box"
  startDateLabel="Début"
  endDateLabel="Fin"
  (onValueChanged)="onValueChanged($event)"
>
</dx-date-range-box>
